import SeatplanAreas from '../../../store/seatplans/areas/index';

angular
    .module('festzelt-os.seatplans')
    .factory('SeatplanAreas', [
        '$injector',
        'SeatplanArea',
        ($injector, SeatplanArea) => new SeatplanAreas(SeatplanArea, {
            injector: $injector
        })
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/seatplans/store/areas.js